import React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSkipRecording } from './hooks/useSkipRecording';

export const SkipRecording: React.FC = () => {
	const {
		actions: { handleSkip },
	} = useSkipRecording();

	return (
		<Button
			data-testid="create-comment"
			data-qa="create-comment"
			variant="secondary"
			onClick={handleSkip}
			className="w-full md:w-1/2"
		>
			<Translate value="corgi.petition_actions.invite.write_button.label" />
		</Button>
	);
};
